import { Toaster } from "components/notification/Toaster";
import { useDispatch } from "react-redux";
import { getPermissionDescriptions_failure, getPermissionDescriptions_request, getPermissionDescriptions_success } from "../slices/userManagement.slices";
import usePromiseInstance_authorization from "./config";

export default function useUserManagement() {
    const dispatch = useDispatch();
    const request = usePromiseInstance_authorization();

    function getPermissionDescriptions() {
        dispatch(getPermissionDescriptions_request());

        request(getPermissionDescriptions_request, (axios) => {    
            axios.get('/General/GetPermissionDesc')
                .then((response) => {
                    dispatch(getPermissionDescriptions_success(response.data));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load permission description(s)";
					Toaster({ type: "error", msg });

                    dispatch(getPermissionDescriptions_failure(msg));
                })
        })
    }

    return {
        getPermissionDescriptions
    }
}